// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const LibreOfficeIcon = createSvgIcon(
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24">
    <path
      fill="url(#libreOffice_svga)"
      d="M5 3.85v16.3c0 .6.25.85.84.85h12.94c.6 0 .85-.25.85-.84v-10.1c0-.3-.11-.6-.32-.81l-5.93-5.93c-.21-.2-.51-.32-.8-.32H5.83a.83.83 0 0 0-.84.85"
    />
    <path
      fill="url(#libreOffice_svgb)"
      d="M15.5 3c-.38.13-.5.7-.22.96l3.4 3.41c.3.3.93.04.95-.39v-3.4c0-.3-.27-.57-.57-.57H15.5"
    />
    <path
      fill="url(#libreOffice_svgc)"
      d="M5.84 3.85v16.31h12.94V9.92l-.09-.1-5.87-5.9-.07-.07z"
    />
    <path
      fill="url(#libreOffice_svgd)"
      d="M6.4 4.41h5.95l5.87 5.91v9.28H6.4z"
    />
    <path
      fill="url(#libreOffice_svge)"
      d="m15.5 4 3.33 3.33-.1.1-3.32-3.33z"
      opacity={0.25}
    />
    <path
      fill="url(#libreOffice_svgf)"
      d="m12.98 3.86 5.85 5.86-.1.1-5.85-5.86z"
      opacity={0.25}
    />
    <path
      fill="url(#libreOffice_svgg)"
      d="M5.84 4.26V19.6H5.7V4.26z"
      opacity={0.25}
    />
    <path
      fill="url(#libreOffice_svgh)"
      d="M16.11 20.3H8.38v-.14h7.73z"
      opacity={0.25}
    />
    <path
      fill="url(#libreOffice_svgi)"
      d="M11.05 14.95h-4.5v4.5h4.5z"
      opacity={0.15}
    />
    <path
      fill="url(#libreOffice_svgj)"
      d="M13.58 14.95h4.5v4.5h-4.5z"
      opacity={0.15}
    />
    <path
      fill="url(#libreOffice_svgk)"
      d="M6.27 7.79V4.27h3.51v.14H6.41V7.8z"
      opacity={0.1}
    />
    <path
      fill="url(#libreOffice_svgl)"
      d="m12.7 4.56 5.85 5.86-.1.1-5.86-5.86z"
      opacity={0.1}
    />
    <path
      fill="url(#libreOffice_svgm)"
      d="M6.4 19.6h11.82v.13H6.41z"
      opacity={0.2}
    />
    <defs>
      <linearGradient
        id="libreOffice_svga"
        x1={16.6}
        x2={16.6}
        y1={3.01}
        y2={21.06}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#666" />
        <stop offset={1} stopColor="#333" />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgb"
        x1={3.78}
        x2={3.78}
        y1={2.92}
        y2={21.17}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#666" />
        <stop offset={1} stopColor="#333" />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgc"
        x1={7.25}
        x2={7.34}
        y1={19.31}
        y2={4.16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B3B3B3" />
        <stop offset={1} stopColor="#E6E6E6" />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgd"
        x1={6.72}
        x2={6.72}
        y1={13.79}
        y2={4.69}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.59} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.86} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svge"
        x1={15.44}
        x2={18.83}
        y1={3.93}
        y2={7.33}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgf"
        x1={12.93}
        x2={18.83}
        y1={3.82}
        y2={9.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgg"
        x1={5.84}
        x2={5.84}
        y1={4.26}
        y2={19.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgh"
        x1={16.11}
        x2={8.38}
        y1={20.3}
        y2={20.3}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgi"
        x1={6.55}
        x2={8.64}
        y1={19.45}
        y2={17.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.45} stopOpacity={0.36} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgj"
        x1={18.08}
        x2={15.99}
        y1={19.45}
        y2={17.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.45} stopOpacity={0.36} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgk"
        x1={6.25}
        x2={8.07}
        y1={4.3}
        y2={6.12}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgl"
        x1={12.65}
        x2={18.55}
        y1={4.52}
        y2={10.42}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="libreOffice_svgm"
        x1={6.41}
        x2={18.22}
        y1={19.59}
        y2={19.59}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.49} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>,
  "LibreOffice",
);
export default LibreOfficeIcon;
